import { useContext } from 'react';
import { AuthContext } from './store';
// Services

import Services from './services';
// Actions
import * as Actions from './actions';

const useAuthState = () => {
  const [state, dispatch] = useContext(AuthContext);
  const store = {
    state: { ...state },
    services: { ...Services(dispatch, Actions) },
  };

  return store;
};

export { useAuthState };
